import {
  Row,
  Col,
  Card,
  Icon,
  DatePicker,
  // Input,
  // Table,
  Select,
  Button,
  // Tag,
  Radio,
  Spin,
  // Avatar
} from "antd"
import React, { useEffect, useRef, useState } from 'react'
import BarChart from "../../shared-charts/BarChart"
import PieChart from "../../shared-charts/PieChart";
import './styles/style.css';
import LeaderBoard from "./grid/LeaderBoard";
import { BOBADMIN, BOBREVIEWADMIN, EA, EXTERNAL_RAC_COMPLETED_BY_CLIENT
  , EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES,
   REVIEWADMIN,
  //  REVIEWSCHEDULER, RS_ADMIN_PATH, SUPER_ADMIN , FOLLOW_UP_SPECIALIST_ADMIN, REVIEW_ADMIN,
   } from "../../../../utils/Constants";
import CommonHeader from "../../CommonHeader";
import axios from "axios";
import {
  GET_RS_APPOINTMENT_STATS, GET_RS_ADMIN_AGENCYS, GET_FS_ADMIN_AGENCYS,
  GET_RS_CALL_STATITICS, GET_RS_LEADERBOARD, GET_RS_OTHER_STATISTICS_PIE, GET_RS_OTHER_STATISTICS_PIE_1, GET_VONBOARD_DROPDOWN_USERS_LIST, GET_FS_CALL_ACTION_STATS, GET_FS_ADMIN_DASHBOARD_STATS, GET_SUB_TYPE_OF_CALL_STATS, GET_TYPE_OF_CALL_STATS, GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS, GET_FS_LEADERBOARD, GET_FS_ADMIN_CALL_STATISTICS, GET_REVIEWADMIN_DROPDOWN_USERS_LIST,
  FIVE_NINE_REPORT
} from "../../../../utils/Api_enums";
import moment from "moment";
import { useBoundStore } from "../../../../store/useBoundStore";
import { GET_GRID_CARD_ROWDATA } from "./grid/RS-FS-Admin-Buckets";
import F from './../../../../Functions'
import { Translate } from "react-translated";
import { useRangePickerCloseButton } from '../../../../utils/rangePickerCloseButton';


// const { RangePicker } = DatePicker;
const { Option } = Select;

const shouldHideBadPhoneNumber = (filters) =>
  filters.hideBadPhoneNumber === undefined
    ? true
    : Boolean(filters.hideBadPhoneNumber);

const REVIEWADMINLAYOUT = (props) => {
  const [open, setOpen] = useState(false);
  useRangePickerCloseButton(open, setOpen);
  const { resetRSFSCardFilters, RSFSCardFilters, setRSFSCardFilters, setRSFSFilters } = useBoundStore();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { user, auth } = props;
  const [users, setUsers] = useState([]);
  const [followUpAdminUsers, setFollowUpAdminUsers] = useState([]);
  const [selectedValue, setSelectedValue] = useState(RSFSCardFilters.dateRangeAdminFilter);
  const [isGridVisible, setGridVisible] = useState(RSFSCardFilters.showLeaderBoardGrid);
  const [userType, setUserType] = useState();
  const [followBarResponse1, setFollowUpBarResponse1] = useState({});
  const [followBarResponse2, setFollowUpBarResponse2] = useState({});
  const [followPieResponse1, setFollowUpPieResponse1] = useState({});
  const [followPieResponse2, setFollowUpPieResponse2] = useState({});
  const [reviewBarResponse1, setReviewBarResponse1] = useState({});
  const [reviewBarResponse2, setReviewBarResponse2] = useState({});
  const [reviewPieResponse1, setReviewPieResponse1] = useState({});
  const [reviewPieResponse2, setReviewPieResponse2] = useState({});
  const [agencies, setAgencies] = useState([]);
  // const [selectedAgencies, setSelectedAgencies] = useState(undefined);
  const [usersPage, setUserPage] = useState();
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  const [loading, setLoading] = useState(false);
  const [loadingLeaderBoard, setloadingLeaderBoard] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  // const [selectedUser, setSelectedUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [fetching, setFetching] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(RSFSCardFilters.selectedUserId);
  const [five9Map, setFive9Map] = useState({});
  const hideBadPhoneNumber = shouldHideBadPhoneNumber(RSFSCardFilters);

  const handleViewMontlyReportClick = () => {
    props.history.push('/dashboard/monthly-report');
  }

  const handleBadPhoneNumberToggle = (event) => {
    const hideBadPhoneNumber = event.target.checked ? 1 : 0;
    setRSFSCardFilters({ hideBadPhoneNumber });
    setRSFSFilters({ hideBadPhoneNumber });
    getStatisticsData();
  };


  const initialDateRange = RSFSCardFilters.datemodified || {
    start_date: "2010-01-01",
    end_date: "2050-01-01",
  };

  const [datemodified, setdatemodified] = useState(initialDateRange);
  const dateFormat = "MM-DD-YYYY";



  const handleDateChange = async (date, dateType) => {
    setSelectedValue(0);
    setRSFSCardFilters({ selectedButton: 'None' });

    const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;

    // Update state for date selection
    setdatemodified((prev) => ({
      ...prev,
      [dateType]: formattedDate
    }));

    // Update filters separately
    setRSFSCardFilters((prev) => ({
      ...prev,
      datemodified: {
        ...prev.datemodified,
        [dateType]: formattedDate,
      },
    }));

    // If both dates are selected, fetch data
    if (dateType === "start_date" && formattedDate && datemodified.end_date) {
      const dateRange = {
        start_date: formattedDate,
        end_date: datemodified.end_date,
      };
      setRSFSCardFilters({ datemodified: dateRange });
      fetchChartDateRangeData(dateRange);
    } else if (dateType === "end_date" && formattedDate && datemodified.start_date) {
      const dateRange = {
        start_date: datemodified.start_date,
        end_date: formattedDate,
      };
      setRSFSCardFilters({ datemodified: dateRange });
      fetchChartDateRangeData(dateRange);
    }

  };


  const handleRangeChange = async (dates) => {
    setSelectedValue(0);
    setRSFSCardFilters({ selectedButton: 'None' });

    const start = dates && dates[0]
      ? moment(dates[0]).format("YYYY-MM-DD")
      : null;

    const end = dates && dates[1]
      ? moment(dates[1]).format("YYYY-MM-DD")
      : null;


    setdatemodified((prev) => ({
      ...prev,
      start_date: start,
      end_date: end
    }));


    setRSFSCardFilters((prev) => ({
      ...prev,
      datemodified: {
        ...prev.datemodified,
        start_date: start,
        end_date: end,
      },
    }));


    if (start && end) {
      const dateRange = {
        start_date: start,
        end_date: end,
      };

      setRSFSCardFilters({ datemodified: dateRange });
      fetchChartDateRangeData(dateRange);
    }
  };


  const gridRef = useRef(null);
  const leaderBoardGridRef = useRef();

  const toggleGrid = () => {
    setGridVisible((prev) => {
      const newVal = !prev;
      setRSFSCardFilters({ showLeaderBoardGrid: newVal })
      if (!prev) {
        setTimeout(() => {
          gridRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      return newVal;
    });
  };


  useEffect(() => {
    if (RSFSCardFilters.hideBadPhoneNumber === undefined) {
      setRSFSCardFilters({ hideBadPhoneNumber: 1 });
    }
  }, []);


  useEffect(() => {
    setUserType(RSFSCardFilters.selectedAdminToggle);
    getStatisticsData();
  }, [RSFSCardFilters.selectedAdminToggle]);


  const getStatisticsData = async () => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;
    const selectedAdminToggle = zustandState.selectedAdminToggle;
    const userId = zustandState.selectedUserId;

    if (selectedAdminToggle == REVIEWADMIN) {
      const data = await getAllReviewAdminData(selectedAdminToggle, datemodified.start_date, datemodified.end_date, userId);
      getStaticDataReviewAdmin(data.callStatistics, data.appointmentStats, data.otherStatistics, data.otherStatistics1, data.totalCalls, data.totalAppointmentStats, datemodified.start_date, datemodified.end_date);
    } else {
      const data = await getAllFollowUpAdminData(datemodified.start_date, datemodified.end_date, userId);
      getStaticDataFollowUpAdmin(data.appointmentStats, data.totalAppointmentStats, datemodified.start_date,
        datemodified.end_date, data.typeOfCallStats, data.subTypeOfCallStats, data.callStatistics, data.callStatsBarResponseList,
        data.totalCallStatistics);
    }
  }


  const fetchChartDateRangeData = async (dateRange) => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;
    const userId = zustandState.selectedUserId;
    if (userType == REVIEWADMIN) {
      const data = await getAllReviewAdminData(userType, dateRange.start_date, dateRange.end_date, userId);
      getStaticDataReviewAdmin(data.callStatistics, data.appointmentStats, data.otherStatistics, data.otherStatistics1,
        data.totalCalls, data.totalAppointmentStats, dateRange.start_date, dateRange.end_date);
    } else {
      const data = await getAllFollowUpAdminData(dateRange.start_date, dateRange.end_date, userId);
      getStaticDataFollowUpAdmin(data.appointmentStats, data.totalAppointmentStats, dateRange.start_date,
        dateRange.end_date, data.typeOfCallStats, data.subTypeOfCallStats, data.callStatistics, data.callStatsBarResponseList,
        data.totalCallStatistics);
    }
  }



  const handleRadioChange = async (e) => {
    setLoading(true);
    setSelectedValue(e);
    let dateRange = {
      start_date: "",
      end_date: "",
    };

    if (e == 1) {
      setRSFSCardFilters({ selectedButton: 'AllBFiles' });
      dateRange.start_date = "2010-01-01";
      dateRange.end_date = "2050-01-01";
      setdatemodified(dateRange);
    }

    else if (e == 2) {
      setRSFSCardFilters({ selectedButton: 'None' });
      const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
      dateRange.start_date = yesterday;
      dateRange.end_date = yesterday;
      setdatemodified(dateRange);
    }

    else if (e == 3) {
      setRSFSCardFilters({ selectedButton: 'None' });
      const today = moment().format('YYYY-MM-DD');
      dateRange.start_date = today;
      dateRange.end_date = today;
      setdatemodified(dateRange);
    } else {

      //this month
      setRSFSCardFilters({ selectedButton: 'ThisMonth' });
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
      dateRange.start_date = startOfMonth;
      dateRange.end_date = endOfMonth;
      setdatemodified(dateRange);

    }
    setRSFSCardFilters({ datemodified: dateRange, dateRangeAdminFilter: e });

    fetchChartDateRangeData(dateRange);

  }





  const getRSAdminAgencys = async (user_type) => {
    try {
      const res = await axios.get(`${GET_RS_ADMIN_AGENCYS}?user_type=${user_type}`);

      if (res.data.data.length > 0) {
        setAgencies(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching agencies:", error);
    }
  };


  const getFSAdminAgencys = async (user_type) => {
    try {
      const res = await axios.get(`${GET_FS_ADMIN_AGENCYS}?user_type=${user_type}`);

      if (res.data.data.length > 0) {
        setAgencies(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching agencies:", error);
    }
  };

  const getAllFollowUpAdminData = async (startDate, endDate, userId) => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;
    let userType = BOBADMIN;
    setLoading(true);
    try {
      let type = "all";

      const userIdsParam = zustandState.selectedLeaderBoardUsers || [];
      let userIdsQuery = '';
      if (userIdsParam.length > 0) {
        userIdsQuery = userIdsParam.map(u => `user_id=${u.key}`).join("&");
      }
      const userIdsParamStr = userIdsQuery ? `&${userIdsQuery}` : '';
      const badPhoneNumberParam = shouldHideBadPhoneNumber(zustandState)
        ? "&bad_phone_number_status=false"
        : "";
      const GET_FS_LEADERBOARD_URL = `${GET_FS_LEADERBOARD}?user_type=${userType}&start_date=${startDate}&end_date=${endDate}&page=1${userIdsParamStr}${badPhoneNumberParam}`;

      const params = `start_date=${startDate}&end_date=${endDate}`;
      const userIdParam = userId ? `&scheduler_specialist_id=${userId}` : "";

      const apiCalls = [
        axios.get(`${GET_FS_CALL_ACTION_STATS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_SUB_TYPE_OF_CALL_STATS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_TYPE_OF_CALL_STATS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_VONBOARD_DROPDOWN_USERS_LIST}?rolename_param=${type}`),
        axios.get(`${GET_FS_LEADERBOARD_URL}`),
        axios.get(`${GET_FS_ADMIN_CALL_STATISTICS}?user_type=${userType}&start_date=${startDate}&end_date=${endDate}${userIdParam}${badPhoneNumberParam}`)
      ];

      const results = await Promise.allSettled(apiCalls);

      const [
        callStatisticsResult,
        subTypeOfCallResult,
        appointmentStatsResult,
        typeOfCallResult,
        userListResult,
        fsSchedularUserListResult,
        callStatsBarResult
      ] = results;




      const callStatistics = callStatisticsResult.status === "fulfilled" ? callStatisticsResult.value.data.data || {} : {};
      const subTypeOfCallStats = subTypeOfCallResult.status === "fulfilled" ? subTypeOfCallResult.value.data.data || {} : {};
      const appointmentStats = appointmentStatsResult.status === "fulfilled" ? appointmentStatsResult.value.data.data || {} : {};
      const typeOfCallStats = typeOfCallResult.status === "fulfilled" ? typeOfCallResult.value.data.data || {} : {};
      const userList = userListResult.status === "fulfilled" ? userListResult.value.data["Virtual On-Boarding1"] || [] : [];
      const fsSchedularUserList = fsSchedularUserListResult.status === "fulfilled" ? fsSchedularUserListResult.value.data.data || [] : [];
      const callStatsBarResponseList = callStatsBarResult.status === "fulfilled" ? callStatsBarResult.value.data.data || [] : [];


      await getFSAdminAgencys(userType);

      const updatedUsers = userList.map(user => ({
        ...user,
        start_date: startDate,
        end_date: endDate
      }));

      const updatedFSchedularUsers = fsSchedularUserList.map(user => ({
        ...user,
        start_date: startDate,
        end_date: endDate
      }));


      setFollowUpAdminUsers(updatedFSchedularUsers);
      setUserPage(1);


      // 🔥 Fire Five9 separately (non-blocking)
      //fetchFive9AndMerge(updatedUsers, startDate, endDate, FOLLOW_UP_SPECIALIST_ADMIN);

      const totalAppointmentStats = getFollowUpTotalAppointments(appointmentStats, callStatistics);

      const totalCallStatistics = getFollowUpCallStatistics(callStatistics, callStatsBarResponseList);

      return {
        appointmentStats,
        totalAppointmentStats,
        callStatistics,
        subTypeOfCallStats,
        typeOfCallStats,
        callStatsBarResponseList,
        totalCallStatistics
      };

    } catch (error) {
      console.error("Unexpected error fetching follow-up admin data:", error);
      return {
        appointmentStats: {},
        totalAppointmentStats: {},
        callStatistics: {},
        subTypeOfCallStats: {},
        typeOfCallStats: {},
        callStatsBarResponseList: []
      };
    } finally {
      setLoading(false);
    }
  };





  // Review admin api calls 
  const getAllReviewAdminData = async (userType, startDate, endDate, userId) => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;

    setLoading(true);

    try {
      const agencyIdParam = zustandState.selectedLeaderBoardAgency
        ? `&agency_id=${zustandState.selectedLeaderBoardAgency}`
        : "";

      const userIdsParam = zustandState.selectedLeaderBoardUsers || [];
      const userIdsQuery = userIdsParam.length
        ? "&" + userIdsParam.map(u => `user_id=${u.key}`).join("&")
        : "";

      const badPhoneNumberParam = shouldHideBadPhoneNumber(zustandState)
        ? "&bad_phone_number_status=false"
        : "";

      const leaderboardURL =
        `${GET_RS_LEADERBOARD}?user_type=${userType}&start_date=${startDate}&end_date=${endDate}&page=1${agencyIdParam}${userIdsQuery}${badPhoneNumberParam}`;

      const params = `user_type=${userType}&start_date=${startDate}&end_date=${endDate}`;
      const userIdParam = userId ? `&scheduler_specialist_id=${userId}` : "";

      const apiCalls = [
        axios.get(`${GET_RS_CALL_STATITICS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_RS_APPOINTMENT_STATS}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_RS_OTHER_STATISTICS_PIE}?${params}${userIdParam}${badPhoneNumberParam}`),
        axios.get(`${GET_RS_OTHER_STATISTICS_PIE_1}?${params}${userIdParam}&page=1${badPhoneNumberParam}`),
        axios.get(leaderboardURL),
      ];

      const results = await Promise.allSettled(apiCalls);

      const [
        callStatisticsResult,
        appointmentStatsResult,
        otherStatisticsResult,
        pie2Result,
        userListResult,
      ] = results;

      const callStatistics =
        callStatisticsResult.status === "fulfilled"
          ? callStatisticsResult.value.data.data || {}
          : {};

      const appointmentStats =
        appointmentStatsResult.status === "fulfilled"
          ? appointmentStatsResult.value.data.data || {}
          : {};

      const otherStatistics =
        otherStatisticsResult.status === "fulfilled"
          ? otherStatisticsResult.value.data.data || {}
          : {};

      const otherStatistics1 =
        pie2Result.status === "fulfilled"
          ? pie2Result.value.data.data || {}
          : {};

      const userList =
        userListResult.status === "fulfilled"
          ? userListResult.value.data.data || []
          : [];

      await getRSAdminAgencys(userType);

      const updatedUsers = userList.map(user => ({
        ...user,
        start_date: startDate,
        end_date: endDate,
        // dialsMode: 0,
        // totalDials: 0,
        // fsCount: 0,
      }));

      setUsers(updatedUsers);
      setUserPage(1);

      // 🔥 Fire Five9 separately (non-blocking)
      //fetchFive9AndMerge(updatedUsers, startDate, endDate, REVIEWADMIN);

      const totalCalls = getTotalCalls(callStatistics, otherStatistics1);
      const totalAppointmentStats = getTotalAppointments(
        appointmentStats,
        otherStatistics1,
        otherStatistics
      );

      return {
        callStatistics,
        appointmentStats,
        otherStatistics,
        otherStatistics1,
        totalCalls,
        totalAppointmentStats,
      };

    } catch (error) {
      console.error("Unexpected error fetching data:", error);
      return {};
    } finally {
      setLoading(false);
    }
  };



  const fetchFive9AndMerge = async (usersList, startDate, endDate, type) => {
    try {
      // setloadingLeaderBoard(true);

      const res = await axios.get(
        FIVE_NINE_REPORT(startDate, endDate)
      );

      const five9Data = res.data.data || [];
      if (!five9Data.length) return;

      // 🔥 Create lookup map (O(n))
      const five9Map = Object.create(null);

      for (let i = 0; i < five9Data.length; i++) {
        const item = five9Data[i];
        if (item.agent && item.agent !== "[None]") {
          five9Map[item.agent.toLowerCase()] = {
            review_count: 100,
            total_dials: 200,
            fs_count: 300,
            // review_count: item.review_count || 100,
            // total_dials: item.total_dials || 200,
            // fs_count: item.fs_count || 300,
          };
        }
      }

      // 🔥 Merge efficiently
      console.log("Merging Five9 data with users list...");
      console.log("Five9 Map Sample:", five9Map);
      setFive9Map(five9Map);
      const mergedUsers = usersList.map(user => {
        const matched = five9Map[user.email.toLowerCase()] || {};

        if (type === REVIEWADMIN) {
          return {
            ...user,
            dialsMode: matched.review_count || 0,
            totalDials: matched.total_dials || 0,
            fsCount: matched.fs_count || 0,
            // dialsMode: 'R101',
            // totalDials: 'R201',
            // review_count: 'R401'
          };
        } else {
          return {
            ...user,
            // dialsMode: 'F101',
            // totalDials: 'F201',
            // review_count: 'F401'
            dialsMode: matched.fs_count || 0,
            totalDials: matched.total_dials || 0,
            review_count: matched.review_count || 0
          };
        }
      });

      if (type === REVIEWADMIN) {
        setUsers(mergedUsers);
      } else {
        setFollowUpAdminUsers(mergedUsers);
      }

    } catch (error) {
      console.error("Five9 merge error:", error);
    } finally {
      // setloadingLeaderBoard(false);
    }
  };


  const getTotalCalls = (callStatistics, otherStatistics1) => {
    return (callStatistics.dials_made || 0) +
      (callStatistics.upcoming_calls || 0) +
      (callStatistics.due_calls || 0) +
      // (callStatistics.call_attempts || 0);
      (otherStatistics1.total_call_attempts || 0) +
      (callStatistics.rs_queued_count || 0)
  };

  const getTotalAppointments = (appointmentStats, otherStatistics1, otherStatistics) => {
    return (appointmentStats.phone_appointments || 0) +
      (appointmentStats.office_appointments || 0) +
      (appointmentStats.virtual_appointments || 0) +
      (otherStatistics1.total_call_backs || 0) +
      (appointmentStats.reschedule_appointments || 0) +
      (otherStatistics.external_rac_files_count || 0)
  };


  const getFollowUpTotalAppointments = (appointmentStats, callStatistics) => {
    return (appointmentStats.phone_appointments || 0) +
      (appointmentStats.office_appointments || 0) +
      (appointmentStats.virtual_appointments || 0) +
      (appointmentStats.call_back_appointments || 0) +
      (appointmentStats.reschedule_appointments || 0) +
      (callStatistics.total_call_backs || 0) +
      (callStatistics.external_rac_files_count || 0)
  };

  const getFollowUpCallStatistics = (callStatistics, callStatsBarResponseList) => {
    return (callStatsBarResponseList.upcoming_calls || 0) +
      (callStatsBarResponseList.dials_made || 0) +
      (callStatsBarResponseList.due_calls || 0) +
      (callStatistics.total_call_attempts) +
      // (callStatsBarResponseList.queued_files || 0) + 
      (callStatsBarResponseList.lead_queued_files || 0) +
      (callStatsBarResponseList.opportunity_queued_files || 0)
  }


  const getStaticDataFollowUpAdmin = async (appointmentStats, totalAppointmentStats, startDate, endDate,
    typeOfCallStats, subTypeOfCallStats, callStatistics, callStatsBarResponseList, totalCallStatistics) => {


    const reviewBarResponse1Order = ["dials_made", "upcoming_calls", "due_calls", "total_call_attempts", 'lead_queued_files', 'opportunity_queued_files'];
    const reviewBarResponse2Order = ["phone_appointments", "office_appointments", "virtual_appointments", "total_call_backs", "reschedule_appointments", "external_rac_files_count"];
    const reviewPieResponse1Order = [
      "FollowUp",
      "Prospect",
      "Thank You / Referrals",
      "Life Insurance",
      "Cross-Sell",
      "Commercial",
      "Retirement",
      "Re-Quote",
    ];
    const reviewPieResponse2Order = [
      "Win Back",
      "Event Call",
      "bad_phone_number",
      'total_non_responsive',
      'total_not_interested',
      'external_rac_files_count',
      'external_rac_files_count_inactive_agencies',
      'total_appointments'
    ];



    const orderedBucketsReviewBar1 = reviewBarResponse1Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(BOBADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewBar2 = reviewBarResponse2Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(BOBADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewPie1 = reviewPieResponse1Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(BOBADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewPie2 = reviewPieResponse2Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(BOBADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })




    setFollowUpBarResponse1({
      "chartData": {
        "name": "Call Statistics",
        "labels": ["Dials Made", "Upcoming Calls", "Due Calls", "Call Attempts", "Queued in Lead",
          "Queued in Opportunity"
        ],
        "data": [
          callStatsBarResponseList && callStatsBarResponseList.dials_made || 0,
          callStatsBarResponseList && callStatsBarResponseList.upcoming_calls || 0,
          callStatsBarResponseList && callStatsBarResponseList.due_calls || 0,
          callStatistics && callStatistics.total_call_attempts || 0,
          // callStatsBarResponseList && callStatsBarResponseList.queued_files || 0,
          callStatsBarResponseList && callStatsBarResponseList.lead_queued_files || 0,
          callStatsBarResponseList && callStatsBarResponseList.opportunity_queued_files || 0
        ],
        "callCount": totalCallStatistics,
        "date": startDate,
        "dateTo": endDate,
        "backgroundColor": ['#1F9106', '#24B304', '#AD0E0E', '#AD7D0E', '#0E4DAD'],
        "buckets": orderedBucketsReviewBar1
      }
    });

    setFollowUpBarResponse2({
      "chartData": {
        "name": "Appointment Statistics",
        "labels": ["Phone Appointments", "Office Appointments", "Virtual Appointments",
          "Call Back Requested", "Requested to be Rescheduled", EXTERNAL_RAC_COMPLETED_BY_CLIENT
        ],
        "data": [appointmentStats && appointmentStats.phone_appointments || 0,
        appointmentStats && appointmentStats.office_appointments || 0,
        appointmentStats && appointmentStats.virtual_appointments || 0,
        callStatistics && callStatistics.total_call_backs || 0,
        appointmentStats && appointmentStats.reschedule_appointments || 0,
        callStatistics && callStatistics['external_rac_files_count'] || 0,
        ],
        "callCount": totalAppointmentStats,
        "date": startDate,
        "dateTo": endDate,
        "backgroundColor": ['#1F9106', '#24B304', '#1F9106', '#AD0E0E', '#AD7D0E', '#FF00B2'],
        "buckets": orderedBucketsReviewBar2
      }
    });


    setFollowUpPieResponse1({
      dateFrom: startDate,
      dateTo: endDate,
      labels: ['Opportunity', 'Lead', 'Thankyou & Referrals', 'Life Insurance', 'P&C', 'Commercial/Farm', 'Retirement',
        'Re-Quotes'
      ],
      datasets: [{
        data: [
          typeOfCallStats && typeOfCallStats['FollowUp'] || 0,
          typeOfCallStats && typeOfCallStats['Prospect'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Thank You / Referrals'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Life Insurance'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Cross-Sell'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Commercial'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Retirement'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Re-Quote'] || 0,
        ],
        backgroundColor: ['#E91F1F', '#9D9E9D', '#6B8BFF', '#4CAF50', '#FFDE59', '#FF6E00', '#FF00B2', '#7226e3ff'],
        "buckets": orderedBucketsReviewPie1
      }],
    });


    setFollowUpPieResponse2({
      dateFrom: startDate,
      dateTo: endDate,
      labels: ['Win-Back', 'Event Calls', 'Bad Phone Number', 'Non Responsive', 'Not Interested', EXTERNAL_RAC_COMPLETED_BY_CLIENT,
        EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES,
        'Total Scheduled Appointments'],
      datasets: [{
        data: [
          subTypeOfCallStats && subTypeOfCallStats['Win Back'] || 0,
          subTypeOfCallStats && subTypeOfCallStats['Event Call'] || 0,

          callStatistics && callStatistics['total_bad_phone_number'] || 0,
          callStatistics && callStatistics['total_non_responsive'] || 0,
          callStatistics && callStatistics['total_not_interested'] || 0,
          callStatistics && callStatistics['external_rac_files_count'] || 0,
          callStatistics && callStatistics['external_rac_files_count_inactive_agencies'] || 0,
          callStatistics && callStatistics['total_appointments'] || 0
        ],
        backgroundColor: ['#E91F1F', '#9D9E9D', '#6B8BFF', '#4CAF50', '#FFDE59', '#FF6E00', '#00f7ff75', '#FF00B2'],
        "buckets": orderedBucketsReviewPie2
      }],
    });

  }


  const getStaticDataReviewAdmin = (callStatistics, appointmentStats, otherStatistics, otherStatistics1,
    totalCalls,
    totalAppointmentStats, startDate, endDate) => {

    const reviewBarResponse1Order = ["dials_made", "upcoming_calls", "due_calls", "total_call_attempts", 'rs_queued_count'];
    const reviewBarResponse2Order = ["phone_appointments", "office_appointments", "virtual_appointments", "total_call_backs", "reschedule_appointments", "external_rac_files_count"];
    const reviewPieResponse1Order = ["Life Insurance", "P&C Review", "Commercial", "Retirement", "bad_phone_number"];
    const reviewPieResponse2Order = ["total_non_responsive", "total_not_interested", 'external_rac_files_count', 'external_rac_files_count_inactive_agencies', "total_appointments"];

    const orderedBucketsReviewBar1 = reviewBarResponse1Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(REVIEWADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewBar2 = reviewBarResponse2Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(REVIEWADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        ////isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewPie1 = reviewPieResponse1Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(REVIEWADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })


    const orderedBucketsReviewPie2 = reviewPieResponse2Order.map((stat) => {
      const match = GET_GRID_CARD_ROWDATA(REVIEWADMIN).find(bucket => bucket.dashboard_stats == stat);
      return {
        ...(match || { dashboard_stats: stat }),
        showName: false,
        showMoreStats: true,
        //isRSFSAdminDashboardStat: true
      };
    })

    setReviewBarResponse1({
      "chartData": {
        "name": "Call Statistics",
        "labels": ["Dials Made", "Upcoming Calls", "Due Calls", "Call Attempts", "Queued in Review"],
        "data": [
          callStatistics && callStatistics.dials_made || 0,
          callStatistics && callStatistics.upcoming_calls || 0,
          callStatistics && callStatistics.due_calls || 0,
          otherStatistics1 && otherStatistics1.total_call_attempts || 0,
          callStatistics && callStatistics.rs_queued_count || 0
        ],
        "callCount": totalCalls,
        "date": startDate,
        "dateTo": endDate,
        "backgroundColor": ['#1F9106', '#1F9106', '#AD0E0E', '#AD7D0E', '#0E4DAD'],
        "buckets": orderedBucketsReviewBar1
      }
    });


    setReviewBarResponse2({
      "chartData": {
        "name": "Appointment Statistics",
        "labels": [
          "Phone Appointments", "Office Appointments", "Virtual Appointments",
          "Call Back Requested", "Requested to be Rescheduled", EXTERNAL_RAC_COMPLETED_BY_CLIENT
        ],
        "data": [appointmentStats && appointmentStats.phone_appointments || 0,
        appointmentStats && appointmentStats.office_appointments || 0,
        appointmentStats && appointmentStats.virtual_appointments || 0,
        otherStatistics1 && otherStatistics1.total_call_backs || 0,
        appointmentStats && appointmentStats.reschedule_appointments || 0,
        otherStatistics && otherStatistics['external_rac_files_count'] || 0,],
        "callCount": totalAppointmentStats,
        "date": startDate,
        "dateTo": endDate,
        "backgroundColor": ['#1F9106', '#24B304', '#1F9106', '#AD0E0E', '#AD7D0E', '#009dffff'],
        "buckets": orderedBucketsReviewBar2
      }
    });

    setReviewPieResponse1({
      dateFrom: startDate,
      dateTo: endDate,
      labels: ['Life Insurance', 'P&C', 'Commercial/Farm', 'Retirement', 'Bad Phone Number'],
      datasets: [{
        data: [
          otherStatistics && otherStatistics['Life Insurance'] || 0,
          otherStatistics && otherStatistics['P&C Review'] || 0,
          otherStatistics && otherStatistics['Commercial'] || 0,
          otherStatistics && otherStatistics['Retirement'] || 0,
          otherStatistics1 && otherStatistics1['total_bad_phone_number'] || 0,
        ],
        backgroundColor: ['#E91F1F', '#9D9E9D', '#6B8BFF', '#4CAF50', '#7226e3ff'],
        "buckets": orderedBucketsReviewPie1
      }],
    });

    setReviewPieResponse2({
      dateFrom: startDate,
      dateTo: endDate,
      labels: ['Non Responsive', 'Not Interested', EXTERNAL_RAC_COMPLETED_BY_CLIENT,
        EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES,
        'Total Scheduled Appointments'],
      datasets: [
        {
          data: [
            otherStatistics1 && otherStatistics1['total_non_responsive'] || 0,
            otherStatistics1 && otherStatistics1['total_not_interested'] || 0,
            otherStatistics && otherStatistics['external_rac_files_count'] || 0,
            otherStatistics && otherStatistics['external_rac_files_count_inactive_agencies'] || 0,
            otherStatistics1 && otherStatistics1['total_appointments'] || 0],
          backgroundColor: ['#FFDE59', '#FF6E00', '#009dffff', '#00f7ff75', '#FF00B275'],
          "buckets": orderedBucketsReviewPie2
        },
      ],
    });
  };



  const loadMoreUsers = async () => {
    setloadingLeaderBoard(true);

    setUserPage((prev) => prev + 1);
    const nextPage = usersPage + 1;
    const badPhoneNumberParam = shouldHideBadPhoneNumber(
      useBoundStore.getState().RSFSCardFilters
    )
      ? "&bad_phone_number_status=false"
      : "";

    try {
      let res;
      if (userType === REVIEWADMIN) {
        res = await axios.get(
          `${GET_RS_LEADERBOARD}?user_type=${userType}&start_date=${datemodified.start_date}&end_date=${datemodified.end_date}&page=${nextPage}${badPhoneNumberParam}`
        );
      } else {
        res = await axios.get(
          `${GET_FS_LEADERBOARD}?user_type=${userType}&start_date=${datemodified.start_date}&end_date=${datemodified.end_date}&page=${nextPage}${badPhoneNumberParam}`
        );
      }

      if (res.data && res.data.data && res.data.data.length > 0) {
        const enrichedData = res.data.data.map((user) => ({
          ...user,
          start_date: datemodified.start_date,
          end_date: datemodified.end_date,
        }));

        if (userType === REVIEWADMIN) {
          // setUsers((prevUsers) => [...prevUsers, ...enrichedData]);
          setUsers((prevUsers) => {
            const merged = [...prevUsers, ...enrichedData];
            const finalUsers = merged.map((user) => {
              const matched = five9Map[user.email.toLowerCase()] || {};

              return {
                ...user,
                dialsMode: 'R900',
                totalDials: 'R8377',
                fsCount: 'R383'
                // dialsMode: matched.review_count || 0,
                // totalDials: matched.total_dials || 0,
                // fsCount: matched.fs_count || 0,
              };
            });

            return finalUsers;
          });
        } else {
          //setFollowUpAdminUsers((prevUsers) => [...prevUsers, ...enrichedData]);
          setFollowUpAdminUsers((prevUsers) => {
            const merged = [...prevUsers, ...enrichedData];
            const finalUsers = merged.map((user) => {
              const matched = five9Map[user.email.toLowerCase()] || {};
              return {
                ...user,
                dialsMode: 'F900',
                totalDials: 'F8377',
                review_count: 'F383'
                // dialsMode: matched.fs_count || 0,
                // totalDials: matched.total_dials || 0,
                // review_count: matched.review_count || 0,
              };
            });
            return finalUsers;
          })
        }
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setloadingLeaderBoard(false);
    }
  };



  const handleRoleChange = async (newRole) => {
    setAgencies([]);
    setUsers([]);
    setFollowUpAdminUsers([]);
    setGridVisible(false);
    setSelectedValue(1);
    const dateRange = {
      start_date: "2010-01-01",
      end_date: "2050-01-01",
    };
    setdatemodified(dateRange);
    setRSFSCardFilters({
      selectedAdminToggle: newRole,
      selectedAdminToggleAPI: newRole,
      datemodified: dateRange,
      dateRangeAdminFilter: 1,
      showLeaderBoardGrid: false,
      selectedLeaderBoardAgency: undefined,
      selectedLeaderBoardUsers: [],
      selectedUserId: undefined
    });
    setSelectedUserId(undefined);
    setUserType(newRole);
  };


  const refresh = async () => {
    const card = JSON.parse(localStorage.getItem('card')) || {};
    card.user_id = null;
    card.showName = false;
    card.userName = '';
    localStorage.setItem("card", JSON.stringify(card));
    setSelectedUserId(undefined);
    setSearchText("");
    setUserOptions([]);
    const dateRange = {
      start_date: "2010-01-01",
      end_date: "2050-01-01",
    };
    setdatemodified(dateRange);
    setSelectedValue(1);
    setUserPage(1);
    setRSFSCardFilters({
      datemodified: dateRange,
      dateRangeAdminFilter: 1,
      selectedUserId: undefined,
      selectedLeaderBoardUsers: [],
      selectedLeaderBoardAgency: undefined
    });
    handleRadioChange(1);
    if (leaderBoardGridRef.current) {
      leaderBoardGridRef.current.refreshFilters();
    }
  }
  const effectiveUserType = userType || RSFSCardFilters.selectedAdminToggle;
  const placeholder =
    (effectiveUserType === REVIEWADMIN || effectiveUserType === BOBREVIEWADMIN)
      ? "Search Review Scheduler"
      : "Search Follow-Up Specialist";


  const fetchUsersRS = async (searchOrId, isId = false) => {
    setFetching(true);
    try {
      const param = isId ? `user_id=${searchOrId}` : `search_text=${searchOrId}`;
      const response = await axios.get(`${GET_REVIEWADMIN_DROPDOWN_USERS_LIST}?${param}`);
      setUserOptions((response && response.data && response.data.data) || []);
    } catch (err) {
      console.error("Error in fetchUsersRS:", err);
      setUserOptions([]);
    }
    setFetching(false);
  };



  const fetchUsersFS = async (searchOrId, isId = false) => {
    setFetching(true);
    try {
      const param = isId ? `user_id=${searchOrId}` : `search=${searchOrId}`;
      const response = await axios.get(`${GET_VONBOARD_DROPDOWN_USERS_LIST}?rolename_param=all&${param}`);
      setUserOptions(response.data && response.data["Virtual On-Boarding1"] || []);
    } catch (err) {
      console.error("Error in fetchUsersFS:", err);
      setUserOptions([]);
    }
    setFetching(false);
  };


  useEffect(() => {
    if (RSFSCardFilters && RSFSCardFilters.selectedUserId) {
      if (effectiveUserType === REVIEWADMIN || effectiveUserType === BOBREVIEWADMIN) {
        fetchUsersRS(RSFSCardFilters.selectedUserId, true);
      } else {
        fetchUsersFS(RSFSCardFilters.selectedUserId, true);
      }
    }
  }, [RSFSCardFilters.selectedUserId, effectiveUserType]);



  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchText) {
        if (effectiveUserType === REVIEWADMIN || effectiveUserType === BOBREVIEWADMIN) {
          fetchUsersRS(searchText, false);
        } else {
          fetchUsersFS(searchText, false);
        }
      } else {
        setUserOptions([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, effectiveUserType]);



  const handleOnChangeUser = (value) => {
    const card = JSON.parse(localStorage.getItem('card')) || {};
    const selectedUser = userOptions.find(user => user.id === value);
    if (selectedUser) {
      card.userName = selectedUser.name;
      card.user_id = selectedUser.id;
      card.showName = true;
      localStorage.setItem('card', JSON.stringify(card));
    }
    setRSFSCardFilters({ selectedUserId: value });
    setSelectedUserId(value);
    getStatisticsData()

  };

  useEffect(() => {
  }, [userOptions]);


  return (
    <div>

      <CommonHeader user={user} onRoleChange={handleRoleChange} />

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '20px',
        padding: "0px 20px 0px 20px"
      }}>
        <div className="radio-btns-container">
          <Radio.Group value={selectedValue} onChange={(e) => handleRadioChange(e.target.value)}>
            <Radio value={1} className="font-size-13">All</Radio>
            <Radio value={2} className="font-size-13">Yesterday</Radio>
            <Radio value={3} className="font-size-13">Today</Radio>
            <Radio value={4} className="font-size-13">This Month</Radio>
          </Radio.Group>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }} className="reviewadmin-filters-controls">


          <div style={{ marginRight: '-1px', minWidth: '200px' }}>
            <div style={{ position: 'relative' }}>
              <Select
                key={selectedUserId ? "filled" : "empty"}
                showSearch
                allowClear
                className="custom-select hide-selected-tags reviewadmin-user-select"
                style={{ width: 200, height: 39, fontSize: '11px', marginTop: "16px" }}
                inputStyle={{ background: '#fff' }}
                placeholder={placeholder}
                value={selectedUserId ? selectedUserId : undefined} // Force undefined if falsy
                notFoundContent={fetching ? 'Loading...' : null}
                onSearch={setSearchText}
                onChange={(value) => handleOnChangeUser(value)}
                filterOption={false}
                suffixIcon={<Icon type="search" />}
              >
                {
                  userOptions && userOptions.map((opt) => (
                    <Option key={opt.id} value={opt.id} style={{ fontSize: '12px' }}>
                      {opt.name}
                    </Option>
                  ))}
              </Select>
            </div>
          </div>

          <div className="datepicker-rsfs" style={{ marginTop: '-10px' }}>
            <div className="date-container-super-admin">


              <div>
                <div className='datepicker-label-rsfs'>Select Date Range</div>
                <DatePicker.RangePicker
                  style={{ width: 300 }}
                  dropdownClassName="custom-range-picker" //for header
                  open={open}
                  // onOpenChange={(status) => setOpen(status)}
                  onOpenChange={(status) => {
                    if (!status) return;
                    setOpen(true);
                  }}
                  value={[
                    datemodified.start_date ? moment(datemodified.start_date) : null,
                    datemodified.end_date ? moment(datemodified.end_date) : null
                  ]}
                  format={dateFormat}
                  onChange={(dates) => {
                    if (dates && dates.length === 2) {
                      const start = dates[0].format("YYYY-MM-DD");
                      const end = dates[1].format("YYYY-MM-DD");
                      setdatemodified(prev => ({
                        ...prev,
                        start_date: start,
                        end_date: end
                      }));
                      setOpen(true);
                    }
                  }}
                  renderExtraFooter={() => {
                    const start = datemodified.start_date
                      ? moment(datemodified.start_date)
                      : moment();

                    const end = datemodified.end_date
                      ? moment(datemodified.end_date)
                      : moment();

                    return (
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between', gap: 20
                      }}>

                        {/* START CONTROLS */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                          <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                          <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                            <Select
                              showSearch
                              value={start.month()}
                              style={{ width: 100 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(month) => {
                                const newDate = start.clone().month(month);
                                setdatemodified(prev => ({
                                  ...prev,
                                  start_date: newDate,
                                }));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {F.getMonthNames().map((m, i) => (
                                <Option key={i} value={i}>{m}</Option>
                              ))}
                            </Select>

                            <Select
                              showSearch
                              value={start.year()}
                              // className="dateRangedropDown custom-select"
                              style={{ width: 80 }}
                              onChange={(year) => {
                                const newDate = start.clone().year(year);
                                setdatemodified(prev => ({
                                  ...prev,
                                  start_date: newDate,
                                }));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {F.getYears().map((y) => (
                                <Option key={y} value={y}>{y}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>

                        {/* END CONTROLS */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                          <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                          <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                            <Select
                              showSearch
                              value={end.month()}
                              style={{ width: 100 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(month) => {
                                const newDate = end.clone().month(month);
                                setdatemodified(prev => ({
                                  ...prev,
                                  end_date: newDate,
                                }));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {F.getMomentMonths().map((m, i) => (
                                <Option key={i} value={i}>{m}</Option>
                              ))}
                            </Select>

                            <Select
                              showSearch
                              value={end.year()}
                              style={{ width: 80 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(year) => {
                                const newDate = end.clone().year(year);
                                setdatemodified(prev => ({
                                  ...prev,
                                  end_date: newDate,
                                }));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {F.getYears().map((y) => (
                                <Option key={y} value={y}>{y}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>

                        {/* TODAY BUTTON */}
                        <div
                          style={{
                            alignSelf: 'center', cursor: 'pointer',
                            color: '#1890ff',
                            marginTop: '10px'
                          }}
                          onClick={() => {
                            const today = moment().format("YYYY-MM-DD");

                            setdatemodified(prev => ({
                              ...prev,
                              start_date: today,
                              end_date: today
                            }));

                            // setOpen(false);
                          }}
                        >
                          Today
                        </div>

                        {/* VIEW BUTTON */}

                        <div
                          style={{
                            alignSelf: 'center'
                          }}>
                          <Button type="primary"
                            className="borderRadius-28 bg-164897"
                            style={{ marginTop: '15px' }}
                            onClick={() => {

                              setdatemodified(prev => ({
                                ...prev,
                                start_date: datemodified.start_date,
                                end_date: datemodified.end_date,
                              }));


                              handleRangeChange([datemodified.start_date, datemodified.end_date]);
                              setOpen(false);
                            }}
                          >
                            <Translate text={"Apply"}></Translate>
                          </Button>
                        </div>
                      </div>
                    );
                  }}
                />



                {/* <DatePicker.RangePicker
                  style={{ width: 300 }}
                  className='custom-datepicker'
                  open={open}
                 // onOpenChange={(status) => setOpen(status)}
 onOpenChange={(status) => {
 if (!status) return;
 setOpen(true);
}}
                  value={[
                    datemodified.start_date ? moment(datemodified.start_date) : null,
                    datemodified.end_date ? moment(datemodified.end_date) : null
                  ]}
                  format={dateFormat}
                  onChange={(dates) => handleRangeChange(dates)}
                  renderExtraFooter={() => (
                    <div
                      style={{
                        textAlign: 'center', cursor: 'pointer',
                        color: '#1890ff'
                      }}
                      onClick={() => {
                        const today = moment();
                        handleRangeChange([today, today]);
                        setOpen(false);
                      }}
                    >
                      Today
                    </div>
                  )}
                /> */}
              </div>


              {/* <div>
                <div className='datepicker-label-rsfs'>Start Date</div>
                <DatePicker
                  style={{ width: 150 }}
                  className='custom-datepicker'
                  value={datemodified.start_date
                    ? moment(datemodified.start_date)
                    : null}
                  format={dateFormat}
                  onChange={(e) => {
                    const newDate = e ? e : moment();
                    handleDateChange(newDate, 'start_date')
                  }} />
              </div>
              <div>
                <div className='datepicker-label-rsfs'>End Date</div>
                <DatePicker
                  style={{ width: 150 }}
                  value={datemodified.end_date
                    ? moment(datemodified.end_date)
                    : null}
                  format={dateFormat}
                  onChange={(e) => {
                    const newDate = e ? e : moment();
                    handleDateChange(newDate, "end_date");
                  }} />
              </div> */}
              <div>
                <Button
                  type="primary"
                  className="bg-164897"
                  style={{
                    marginTop: '16px',
                    borderRadius: '20px'
                  }}
                  onClick={() => refresh()}
                >
                  <Icon type="reload" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '20px',
        marginRight: '20px',
        paddingBottom: '20px'
      }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          minWidth: 'max-content',
          cursor: 'pointer',
          fontWeight: '500',
          color: 'black',
          marginBottom: 0
        }}>
          <input
            type="checkbox"
            checked={hideBadPhoneNumber}
            onChange={handleBadPhoneNumberToggle}
            style={{
              width: '13px',
              height: '13px',
              cursor: 'pointer',
              accentColor: hideBadPhoneNumber ? '#1890ff' : '#9ca3af'
            }}
          />
          <span>Hide Bad Phone Number</span>
        </label>
        <div
          className='hyperlink-shomore-stat'
          role="button"
          tabIndex="0"
          onClick={handleViewMontlyReportClick}
          onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
          onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleViewMontlyReportClick();
            }
          }}
          style={{ minWidth: 'max-content' }}
        >
          <Icon type="bar-chart" />
          View Monthly Report
        </div>
      </div>


      <div>

        <Spin indicator={antIcon} spinning={loading}>
          {/* BarCharts Review Admin*/}
          {/* added check for BOBREVIEWADMIN role  */}
          {(userType === REVIEWADMIN || userType === BOBREVIEWADMIN) && (
            <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '40px' }}>

              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12}>
                <Card bordered={false} >
                  <BarChart response={reviewBarResponse1} userType={REVIEWADMIN} />
                </Card>
              </Col>

              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false}>
                  <BarChart response={reviewBarResponse2} userType={REVIEWADMIN} />
                </Card>
              </Col>
            </Row>
          )}

          {/* BarCharts Follow Admin*/}
          {(userType === EA) && (
            <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '40px' }}>
              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false} >
                  <BarChart response={followBarResponse1} userType={BOBADMIN} />
                </Card>
              </Col>

              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12}>
                <Card bordered={false}>
                  <BarChart response={followBarResponse2} userType={BOBADMIN} />
                </Card>
              </Col>
            </Row>
          )}

          {/* PieCharts (Follow Up Admin) */}
          {(userType === EA) && (
            <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '40px' }}>
              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false} >
                  <PieChart response={followPieResponse1} userType={BOBADMIN} />
                </Card>
              </Col>
              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false} >
                  <PieChart response={followPieResponse2} userType={BOBADMIN} />
                </Card>
              </Col>
            </Row>
          )}



          {/* PieCharts (Review Admin) */}
          {/* added check for REVIEWADMIN role  */}
          {(userType === REVIEWADMIN || userType === BOBREVIEWADMIN) && (
            <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '40px' }}>
              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false} >
                  <PieChart response={reviewPieResponse1} className="marginRight-5" userType={REVIEWADMIN} />
                </Card>
              </Col>
              {/* <Col span={12}> */}
              <Col xs={24} sm={24} md={12} >
                <Card bordered={false} >
                  <PieChart response={reviewPieResponse2} userType={REVIEWADMIN} />
                </Card>
              </Col>
            </Row>
          )}

          < div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Button type="primary" className="bg-164897 mt-20 mb-20 rounded-20"
              onClick={toggleGrid} >
              <Icon type="bar-chart" />
              Performance Leaderboard
            </Button>
          </div>



          {/* Ag-grid */}
          {
            (isGridVisible || RSFSCardFilters.showLeaderBoardGrid) && (
              <div ref={gridRef}>
                <Card bordered={false}>
                  <Spin indicator={antIcon} spinning={loadingLeaderBoard}>
                    <LeaderBoard
                      isRefreshing={isRefreshing}
                      ref={leaderBoardGridRef}
                      user={users}
                      setUsers={setUsers}
                      setFollowUpAdminUsers={setFollowUpAdminUsers}
                      setUserPage={setUserPage}
                      props={props}
                      userType={userType}
                      agencies={agencies}
                      followUpAdminUsers={followUpAdminUsers}
                      datemodified={datemodified}
                    // myStyles={}
                    />
                    {(users.length >= 10 ||
                      followUpAdminUsers.length >= 10) && (
                        <Button onClick={loadMoreUsers}
                          className="borderRadius-28 bg-164897"
                          type="primary"
                          style={{
                            display: 'block',
                            margin: "10px auto"
                          }}>
                          <Icon type="down-circle" />
                          Load More
                        </Button>
                      )}
                  </Spin>
                </Card>
              </div>
            )
          }
        </Spin>

      </div>

    </div >
  )
}

export default REVIEWADMINLAYOUT



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/ReviewAdminLayout.js